import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "resource-scroll-area iodine-scrollable-y" }
const _hoisted_2 = {
  key: 0,
  class: "iodine-padding-bottom-md iodine-padding-top-md"
}

import ResearchItemsContainer from 'components/resources/ResearchSectionContainer.vue';
  import { useResourcesStore } from 'src/stores/resourcesStore';
  import {storeToRefs} from 'pinia';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ResearchPane',
  setup(__props) {

  const {researchMetadata} = storeToRefs(useResourcesStore());


return (_ctx: any,_cache: any) => {
  const _component_q_separator = _resolveComponent("q-separator")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(researchMetadata), (section, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: section.research_type
      }, [
        (index !== 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_q_separator)
            ]))
          : _createCommentVNode("", true),
        _createVNode(ResearchItemsContainer, {
          codeType: _unref(researchMetadata),
          "research-section-data-model": section
        }, null, 8, ["codeType", "research-section-data-model"])
      ]))
    }), 128))
  ]))
}
}

})